export enum ERentDepositTabs {
  Info,
  History,
}

export interface IRentDepositDetailProps {
  rentDepositId: number;
  onDrawerClose: () => void;
}
